export default __webpack_public_path__ + "static/media/pdf-logo.e281669c.svg";